import { render, staticRenderFns } from "./BalanceActivityList.vue?vue&type=template&id=45ebbbfb"
import script from "./BalanceActivityList.vue?vue&type=script&lang=js"
export * from "./BalanceActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports